import { gql } from "@apollo/client";export default gql`mutation DeleteBlockTagMap($ids: [Int!]) {
    delete_worksheet_block_tag_map(where: { id: { _in: $ids } }) {
        affected_rows
    }
}
`;
